import React from 'react';
import { HeadphonesIcon, SettingsIcon, GraduationCapIcon, LifeBuoyIcon } from 'lucide-react';
type OnboardingStep = {
  icon: React.ReactNode;
  title: string;
  text: string;
};
export function OnboardingSection() {
  const steps: OnboardingStep[] = [{
    icon: <HeadphonesIcon className="w-6 h-6" strokeWidth={2} data-id="element-106" />,
    title: '20-Minute Onboarding Call',
    text: 'We walk through everything together—no homework on your end.'
  }, {
    icon: <SettingsIcon className="w-6 h-6" strokeWidth={2} data-id="element-107" />,
    title: 'We Connect Your Channels',
    text: 'Yelp, Meta, Google, your website—we plug them all into one system.'
  }, {
    icon: <GraduationCapIcon className="w-6 h-6" strokeWidth={2} data-id="element-108" />,
    title: 'Live Dashboard Walkthrough',
    text: 'See your pipeline, leads, and follow-ups in action before we hang up.'
  }, {
    icon: <LifeBuoyIcon className="w-6 h-6" strokeWidth={2} data-id="element-109" />,
    title: 'Ongoing Support',
    text: "Questions after launch? We're here via email and chat—no ticket queues."
  }];
  return <section className="w-full bg-white py-16 md:py-24 px-4" data-id="element-110">
      <div className="max-w-5xl mx-auto" data-id="element-111">
        <div className="text-center mb-12" data-id="element-112">
          <h2 className="text-3xl md:text-5xl font-extrabold text-jet-black mb-6" data-id="element-113">
            Not Tech-Savvy?{' '}
            <span className="text-viridia-green" data-id="element-114">We Handle Everything.</span>
          </h2>
          <p className="text-lg md:text-xl text-graphite-gray max-w-3xl mx-auto leading-relaxed" data-id="element-115">
            Our team connects your Yelp, Meta, and Google lead sources, sets up
            your booking flow, customizes your follow-up sequences, and trains
            you on the dashboard—all included with the Growth plan.
          </p>
        </div>

        <div className="bg-gradient-to-br from-viridia-green to-deep-teal rounded-2xl shadow-xl p-8 md:p-12" data-id="element-116">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-117">
            {steps.map((step, index) => <div key={index} className="flex items-start gap-4 bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/15" data-id="element-118">
                <div className="flex-shrink-0 w-12 h-12 bg-white text-viridia-green rounded-xl flex items-center justify-center" data-id="element-119">
                  {step.icon}
                </div>
                <div data-id="element-120">
                  <h3 className="text-lg font-bold text-white mb-1" data-id="element-121">
                    {step.title}
                  </h3>
                  <p className="text-sm text-white/70" data-id="element-122">{step.text}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}